import {
    AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef,
    Component, HostBinding, OnDestroy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { CommonFieldManagerDirective, FIELD_TOKEN } from "../../field-manager.directive";
import { FieldStateService } from "../../field-state.service";
import { DropdownStateService } from "./dropdown-state.service";

@Component({
    selector: "common-dropdown",
    templateUrl: "./common-dropdown.component.html",
    providers: [
        { provide: FieldStateService, useClass: DropdownStateService },
        { provide: FIELD_TOKEN, useValue: "commonFormDropdowns" },
        CommonFieldManagerDirective,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonDropdownComponent implements OnDestroy, AfterViewInit {
    public state$: Subscription;
    public typeAheadModel = "";
    public typeAheadInput = "";

    @HostBinding("class.u-display-flex") public isFlex = true;

    constructor(
        public fieldManager: CommonFieldManagerDirective,
        public fieldStateService: FieldStateService,
        public changeDetectorRef: ChangeDetectorRef,
    ) { }

    public ngAfterViewInit() {
        this.state$ = this.fieldStateService.stateObservable$.subscribe((state) => {
            if (this.isTypeAhead) {
                this.typeAheadModel = state.selectedValue;
                this.typeAheadInput = state.selectedLabel || "";
                this.changeDetectorRef.markForCheck();
            }
        });
    }

    public ngOnDestroy() {
        this.state$.unsubscribe();
    }

    public get isSimpleDropdown(): boolean {
        return this.fieldManager.fieldType === "dropdown";
    }

    public get isFilteredDropdown(): boolean {
        return this.fieldManager.fieldType === "filteredDropdown";
    }

    public get isTypeAhead(): boolean {
        return this.fieldManager.fieldType === "typeahead";
    }

    public get optionsExhausted() {
        if (!!this.fieldManager && this.fieldManager.fieldOptions) {
            return this.fieldManager.fieldOptions.length === 0;
        } else {
            return false;
        }
    }

    public onTypeAheadBlur(e) {
        if (e.target.value !== "") {
            if (!this.fieldManager.fieldOptions.find((option) => option.label === e.target.value)) {
                this.fieldManager.dispatchFormFieldChange("");
                this.fieldManager.dispatchFieldUpdate("");
                e.target.value = "";
            } else {
                e.target.value = this.typeAheadInput = this.fieldManager.selectedFieldLabel;
            }
            this.changeDetectorRef.markForCheck();
        } else {
            this.fieldManager.dispatchFormFieldChange("");
            this.fieldManager.dispatchFieldUpdate("");
        }
    }
}
